import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var DutiesInvoiceIA = function DutiesInvoiceIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize), YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_INVOICES_WITH_FAIRE = function DUTIES_INVOICES_WITH_FAIRE(strictLocalize) {
  return strictLocalize({
    id: "GUFPUU",
    defaultMessage: [{
      "type": 0,
      "value": "Invoerrechtenfacturen bij Faire"
    }]
  });
};
var ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE = function ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize) {
  return strictLocalize({
    id: "nV464S",
    defaultMessage: [{
      "type": 0,
      "value": "Alle bestellingen met goederen die in aanmerking komen voor invoerrechten genereren een invoerrechtenfactuur. Als invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van invoerrechten voor je bestelling weerspiegelt. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw) wanneer de bestelling wordt verzonden, die je volledig moet betalen. Als de invoerrechten worden gedekt en de werkelijke kosten van invoerrechten en uitbetalingsvergoedingen hoger uitvallen dan de invoerrechtenpromotie die je hebt ontvangen, kun je het verschil terugvragen in Faire-tegoed wanneer de bestelling is geleverd."
    }]
  });
};
var YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES = function YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "XjOUVq",
    defaultMessage: [{
      "type": 0,
      "value": "Als de invoerrechten voor je bestelling niet worden gedekt, ben je zelf verantwoordelijk voor de invoerrechten."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "C5Am+H",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling komt in aanmerking voor de promotie met gratis invoerrechten. Alle bestellingen met goederen die in aanmerking komen voor invoerrechten genereren een invoerrechtenfactuur. Aangezien de invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van de invoerrechten voor je bestelling weergeeft. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw) wanneer de bestelling wordt verzonden, die je volledig moet betalen. Als de werkelijke invoerheffingen hoger uitvallen dan de invoerrechtenpromotie die je hebt ontvangen, kun je het verschil terugvragen in Faire-tegoed."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "0Ut9wH",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling komt niet in aanmerking voor de promotie met gratis invoerrechten. Alle bestellingen met goederen die in aanmerking komen voor invoerrechten genereren een invoerrechtenfactuur. Omdat de invoerrechten voor je bestelling niet worden gedekt, ben je zelf verantwoordelijk voor de invoerrechten. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw) wanneer de bestelling wordt verzonden, die je volledig moet betalen."
    }]
  });
};